// material-ui
import { Box, SxProps } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';

// project import
import { DRAWER_WIDTH } from '../../../config';

// types
import { ThemeMode } from '../../../types/config';

export const openedMixin = (theme: Theme): SxProps => ({
	width: DRAWER_WIDTH,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowX: 'hidden',
	boxShadow: theme.palette.mode === ThemeMode.DARK ? theme.customShadows.z1 : 'none',
});

export const closedMixin = (theme: Theme): SxProps => ({
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: 'hidden',
	width: 0,
	borderRight: 'none',
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Box)(() => ({
	width: DRAWER_WIDTH,
	flexShrink: 0,
	boxSizing: 'border-box',
	position: 'relative',
}));

export default MiniDrawerStyled;
